<template>
	<div
		class="loader-container flex-centerize flex-column"
		:class="{ 'absolute-center': isAbsoluteCenter, 'pointer-events-none': pointerEventsNone }"
	>
		<BuilderLoaderAnimation v-if="showLottie" />
		<!-- TODO: apply this from extension as well -->
		<template v-else>
			<div class="mb-1" v-if="text">{{ text }}</div>
			<div class="loader" :class="{ small, 'primary-color': primary }">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
			<div class="backdrop"></div>
		</template>
	</div>
</template>
<!-- TODO: apply this from extension as well -->
<script>
import BuilderLoaderAnimation from '@/components/common/BuilderLoaderAnimation.vue';
export default {
	name: 'Loader',
	props: {
		text: { type: String },
		small: { type: Boolean },
		primary: { type: Boolean },
		showLottie: { type: Boolean },
		isAbsoluteCenter: { type: Boolean },
		pointerEventsNone: { type: Boolean },
	},
	components: { BuilderLoaderAnimation },
};
</script>

<style scoped lang="scss">
$color: grey;
.loader-container {
	&:not(.absolute-center) {
		height: 100%;
		width: 100%;
	}

	&.absolute-center {
		position: fixed;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
	}
}

.loader {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 64px;
		height: 64px;
		margin: 8px;
		border-width: 8px;
		border-style: solid;
		border-color: $color transparent transparent transparent;
		border-radius: 50%;
		animation: loader-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	}
	div:nth-child(1) {
		animation-delay: -0.45s;
	}
	div:nth-child(2) {
		animation-delay: -0.3s;
	}
	div:nth-child(3) {
		animation-delay: -0.15s;
	}
	&.small {
		width: 40px;
		height: 40px;
		div {
			width: 32px;
			height: 32px;
			margin: 4px;
			border-width: 4px;
			animation: small-loader-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		}
		div:nth-child(1) {
			animation-delay: -0.45s;
		}
		div:nth-child(2) {
			animation-delay: -0.3s;
		}
		div:nth-child(3) {
			animation-delay: -0.15s;
		}
	}
	&.primary-color {
		div {
			border-color: var(--primary-color) transparent transparent transparent;
		}
	}
}
@keyframes small-loader-animation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
@keyframes loader-animation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.backdrop {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background-color: rgba(255, 255, 255, 0.6);
	z-index: -1;
	pointer-events: none !important;
}
</style>
